import { render, staticRenderFns } from "./Managermessages-tot.vue?vue&type=template&id=6ae522cc&"
import script from "./Managermessages-tot.vue?vue&type=script&lang=js&"
export * from "./Managermessages-tot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports